import moment from 'moment-timezone'

/*
  @param date - moment object from react-dates
  this function is calculating days to disable, depends on Kiritimati timezone
  so that means if super-admin works in UTC+2 and his time is 16:00 on Kiritimati it's next day with time 18:00
  for example: 
  superadmin local time: UTC+2 2021.01.20 16:00  
  starting time point to calculate ability to set a day offs: UTC+14 2021.01.21 18:00
  superadmin can set dayoff until the next day will come in Kiritimati timezone
*/

const dateFormat = 'YYYY-MM-DD'

export const disableDays = (date, now = moment.tz('Pacific/Kiritimati')) => {
  const [currentDate, dateToCompare] = [now.format(dateFormat), date.format(dateFormat)]
  if (currentDate === dateToCompare) return true
  return currentDate > dateToCompare
}
